export enum EnumAPI {
  Areas = "Areas",
  Events = "Events",
  Services = "Services",
  Slots = "Slots",
  Presence = "Presence",
  Organizations = "Organizations",
}
